module.exports = __webpack_public_path__ + "static/img/icon8.bc026a96.png";